import { render, staticRenderFns } from "./AddSubscriptions.vue?vue&type=template&id=5ccf7c0a"
import script from "./AddSubscriptions.vue?vue&type=script&lang=ts"
export * from "./AddSubscriptions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports